import React, { Fragment, useEffect, useState } from 'react';
import { Container } from 'semantic-ui-react';
import parse from 'html-react-parser';
import CompletionOfWorksForm from './forms/CompletionOfWorksForm';
import ConnectionServicesEnquiriesForm from './forms/ConnectionServicesEnquiriesForm';
import ContactForm from './forms/ContactForm';
import FeedbackForm from './forms/FeedbackForm';
import HighLoadForm from './forms/HighLoadForm';
import HighVoltageIsolationsForm from './forms/HighVoltageIsolationsForm';
import NonUrgentMaintenanceForm from './forms/NonUrgentMaintenanceForm';
import POELElectricalComplianceDeclarationForm from './forms/POELElectricalComplianceDeclarationForm';
import POELVegetationClearanceComplianceDeclarationForm from './forms/POELVegetationClearanceComplianceDeclarationForm';
import SummerSaverForm from './forms/SummerSaverForm';
import TechnicalStandardsAndWorkPracticesForm from './forms/TechnicalStandardsAndWorkPracticesForm';
import VegetationManagementForm from './forms/VegetationManagementForm';
import ConnectInHomeDeviceForm from './forms/ConnectInHomeDeviceForm';
import RegisteredElectricalContractorsForm from './forms/RegisteredElectricalContractorsForm';

const FormModule = (props) => {
  const { form, title, introContent, subtitle } = props.module;
  const [Form, setForm] = useState(<ContactForm />);

  useEffect(() => {
    switch (form) {
      case 'ContactForm':
        setForm(<ContactForm />);
        break;
      case 'CompletionOfWorksForm':
        setForm(<CompletionOfWorksForm />);
        break;
      case 'ConnectInHomeDeviceForm':
        setForm(<ConnectInHomeDeviceForm />);
        break;
      case 'ConnectionServicesEnquiriesForm':
        setForm(<ConnectionServicesEnquiriesForm />);
        break;
      case 'FeedbackForm':
        setForm(<FeedbackForm />);
        break;
      case 'HighLoadForm':
        setForm(<HighLoadForm />);
        break;
      case 'HighVoltageIsolationsForm':
        setForm(<HighVoltageIsolationsForm />);
        break;
      case 'NonUrgentMaintenanceForm':
        setForm(<NonUrgentMaintenanceForm />);
        break;
      case 'POELElectricalComplianceDeclarationForm':
        setForm(<POELElectricalComplianceDeclarationForm />);
        break;
      case 'POELVegetationClearanceComplianceDeclarationForm':
        setForm(<POELVegetationClearanceComplianceDeclarationForm />);
        break;
      case 'SummerSaverForm':
        setForm(<SummerSaverForm />);
        break;
      case 'TechnicalStandardsAndWorkPracticesForm':
        setForm(<TechnicalStandardsAndWorkPracticesForm />);
        break;
      case 'VegetationManagementForm':
        setForm(<VegetationManagementForm />);
        break;
      case 'RegisteredElectricalContractorsForm':
        setForm(<RegisteredElectricalContractorsForm />);
        break;
      default:
        setForm(<ContactForm />);
    }
  }, [form]);

  return (
    <Fragment>
      {title || introContent || subtitle ? (
        <section className="form-module__section">
          <Container>
            <div className="grid-wrapper">
              <div className="form-container">
                {title ? <h2 className="form-module__title">{title}</h2> : null}
                {introContent ? (
                  <div className="form-module__introContent">
                    {parse(introContent)}
                  </div>
                ) : null}
                {subtitle ? (
                  <h4 className="form-module__subtitle">{subtitle}</h4>
                ) : null}
              </div>
            </div>
          </Container>
        </section>
      ) : null}
      <div
        className={`${
          title || introContent || subtitle
            ? 'form-module__form-padding-override'
            : ''
        }`}
      >
        {Form && Form}
      </div>
    </Fragment>
  );
};
export default FormModule;
